import { bookServiceApi } from '@/services/api';

export interface CharacterRelationshipItem {
  relationship_id: number;
  related_character_id: number;
  related_character_name: string;
  related_character_icon: string | null;
  relationship_type: string;
  status: 'unlocked' | 'locked' | string;
}

export interface CharacterRelationshipsCharacter {
  character_id: number;
  character_name: string;
  character_icon: string | null;
  progress_percentage: number;
  relationships: CharacterRelationshipItem[];
}

export interface CharacterRelationshipsResponse {
  data: {
    characters: CharacterRelationshipsCharacter[];
  };
  is_premium: boolean;
}

export const getCharacterRelationships = async (bookId: number, isSpoil = false): Promise<CharacterRelationshipsResponse> => {
  const res = await bookServiceApi.get<CharacterRelationshipsResponse>(`/novel/books/${bookId}/character-relationships?is_spoil=${isSpoil}`);
  if (res.success && res.data) {
    return res.data;
  }
  throw new Error(res.error || 'Failed to fetch character relationships');
};
